module.exports = __webpack_public_path__ + "img/aby3.d7f92bf5.gif";